var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.633,
    height: 11.889,
    viewBox: "0 0 14.633 11.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #03a9f4;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    className: "cls-1",
    d: "M14.633,49.407a6.254,6.254,0,0,1-1.728.474,2.983,2.983,0,0,0,1.32-1.658,6,6,0,0,1-1.9.726A3,3,0,0,0,7.133,51a3.089,3.089,0,0,0,.07.684,8.491,8.491,0,0,1-6.183-3.138,3,3,0,0,0,.922,4.009,2.962,2.962,0,0,1-1.355-.369v.033a3.014,3.014,0,0,0,2.4,2.948,2.994,2.994,0,0,1-.787.1,2.652,2.652,0,0,1-.568-.051,3.028,3.028,0,0,0,2.8,2.09A6.028,6.028,0,0,1,.718,58.584,5.618,5.618,0,0,1,0,58.543a8.445,8.445,0,0,0,4.6,1.346,8.479,8.479,0,0,0,8.538-8.536c0-.133,0-.261-.011-.388A5.984,5.984,0,0,0,14.633,49.407Z",
    transform: "translate(0 -48)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bde6351853a0d435417918ab201f067f.svg";
export { ForwardRef as ReactComponent };